import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "../../../context/UserContext.component";
import SideBar from "../sidebar/SideBar.component";
import { TopBar } from "../topbar/TopBar.component";
import { useIdleTimer } from "react-idle-timer";
import { apiEndpoint } from "../../../api/apiEndpoint";
import { types } from "../../../context/types";
import { useNavigate } from "react-router-dom";
import ModalTimeOut from "../../ui/ModalTimeOut.component";
import { Logout } from "../../../api/apiLogout";
import { fetchTimeOutData } from "./timeOutApi";

export const Layout = ({ children }) => {
  const { dispatch } = useContext(UserContext);
  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [timeOutData, setTimeOutData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseTimeOut = await fetchTimeOutData(token);
        setTimeOutData(responseTimeOut.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [token]);

  const timeout = timeOutData?.value
    ? timeOutData.value * 60000
    : 1000 * 60 * 40;
  const promptBeforeIdle = timeOutData?.value
    ? timeOutData.value * 0.125 * 60000
    : 1000 * 60 * 35;

  const LogoutTimeOut = async () => {
    await apiEndpoint.post(
      "/v1/user/logout/",
      {},
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    sessionStorage.removeItem("data");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    dispatch({
      type: types["[Logout]"],
    });
    navigate("/sessionTimeOut");
  };

  const onIdle = () => {
    LogoutTimeOut();
  };

  const onPrompt = () => {
    setOpen(true);
  };

  const { reset } = useIdleTimer({
    onIdle,
    onPrompt,
    timeout,
    promptBeforeIdle,
    throttle: 500,
  });
  const handleLogout = () => {
    Logout(dispatch);
  };

  const handleConnected = () => {
    reset();
    setOpen(false);
  };

  return (
    <div className="h-screen">
      <ModalTimeOut
        open={open}
        onClickLogout={handleLogout}
        onClickConnected={handleConnected}
      />
      <div className="w-full fixed top-0 bg-white">
        <TopBar />
      </div>
      <div className="flex h-screen" style={{ marginTop: "66px" }}>
        <div
          className="fixed hidden md:block"
          style={{ height: "calc(100vh - 66px)" }}
        >
          <SideBar />
        </div>
        <div
          className="overflow-y-auto  w-full md:pl-[265px] "
          style={{ height: "calc(100vh - 66px)" }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
